module.exports = {
    "signup": {
        "url": `${process.env.REACT_APP_API_PREFIX}/signup`,
        "callback": "api/signup/lu"
    },
    "user-files-other-documents": {
        "url": `${process.env.REACT_APP_API_PREFIX}/user-files/other-documents`,
        "callback": "api/user-files-other-documents/ch_lu",
        "access": "authenticated"
    },
    "user-migrate": {
        "url": `${process.env.REACT_APP_API_PREFIX}/user-migrate`,
        "callback": "api/user-migrate/lu"
    },
};
